import { useTranslation } from 'react-i18next';
import { formatNumber, WeightAndType } from '@steelbuy/ts-shared';

import './CardContentDynamicDelivery.scss';

export const CardContentDynamicDelivery = ({
    totalPrice,
    totalPriceLablel,
    typeWithWeight,
}: {
    totalPrice: string;
    totalPriceLablel?: string;
    typeWithWeight: WeightAndType[];
}) => {
    const { t } = useTranslation(['translation', 'uiPrimitive', 'domainModel']);

    return (
        <article className="delivery-card">
            <article className="delivery-card__header">
                {t('translation:application.checkoutDeliveryOption.orderSummary')}
            </article>
            <article className="delivery-card__content">
                <article className="delivery-card__content__pricing-weight">
                    <span className="delivery-card__content__pricing-weight__label">
                        {t('translation:application.checkoutDeliveryOption.totalWeight')}
                    </span>

                    {typeWithWeight.map((entry) => (
                        <ul key={entry.type} className="delivery-card__content__pricing-weight__list">
                            <li>{t(`domainModel:material.materialType.value.${entry.type}`)}</li>
                            <span className="delivery-card__content__pricing-weight__list__item__weight">
                                {t(`domainModel:material.tradeUnit.value.${entry.tradeUnit}.quantity`, {
                                    count: entry.weight,
                                    formatted: formatNumber(entry.weight),
                                })}
                            </span>
                        </ul>
                    ))}
                </article>
                <article className="product-view-price__content__total-price">
                    <span className="product-view-price__content__total-price__label">{totalPriceLablel}</span>
                    <span className="product-view-price__content__total-price__value">{totalPrice}</span>
                </article>
            </article>
        </article>
    );
};
